// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 1400px) {
    .vraShiftsMediaQuery {
      width: 76vw;
      /* min-width: 60vw; */
      overflow-x: scroll;
      /* border: 1px solid black !important; */
      justify-content: center;
      text-align: center;

    }
  }
  
  @media only screen and (min-width: 1400px) {
    .vraShiftsMediaQuery {
      width: 80vw;
      /* min-width: 60vw; */
      overflow-x: scroll;
    /* width: 20vw !important; */
    /* border: 1px solid black !important; */
    justify-content: center;
    text-align: center;

    }
  }


  .vraShiftsModalHeading{
    font-family: "Inter";
font-size: 18px;
font-weight: 600;
line-height: 22px;
letter-spacing: 0.02em;
text-align: left;
color:#0070E9;
margin-left: 2%;
margin-bottom: 2%;
    
  }
  .VraShiftsTitle{
    font-family: "Inter";
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0.02em;
    text-align: left;
    color:#0070E9

  }

  .editlabelinroster{
    font-family: "Inter";
    font-size: 16px;
    font-weight: 600;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #002C5D;
    white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
margin-bottom: 5px;
  }

  .allcardsparentgrid{
    justify-content: center !important;
    margin-top: 1% !important;
  }
  .cardinmasterRoster{
    border-radius: 10px;
    margin: auto;
    justify-content: center;
    padding: 20px !important;
  }

  .reset-btnforroster{
    font-family: "Inter"!important;
    font-size: 16px!important;
    font-weight: 600!important;
    margin-right: 20px!important;
    border-radius: 3px!important;
    color: white!important;
    background-color: #fe602f !important;
    /* border: 2px solid #fe602f!important; */
    text-transform: capitalize!important;
    margin: auto;
    justify-content: center;

  }`, "",{"version":3,"sources":["webpack://./src/views/panel/vraShifts/poolPrepRoster/poolPrepRoster.css"],"names":[],"mappings":"AAAA;IACI;MACE,WAAW;MACX,qBAAqB;MACrB,kBAAkB;MAClB,wCAAwC;MACxC,uBAAuB;MACvB,kBAAkB;;IAEpB;EACF;;EAEA;IACE;MACE,WAAW;MACX,qBAAqB;MACrB,kBAAkB;IACpB,4BAA4B;IAC5B,wCAAwC;IACxC,uBAAuB;IACvB,kBAAkB;;IAElB;EACF;;;EAGA;IACE,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,sBAAsB;AACtB,gBAAgB;AAChB,aAAa;AACb,eAAe;AACf,iBAAiB;;EAEf;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB;;EAEF;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB,gBAAgB;AAChB,uBAAuB;AACvB,kBAAkB;EAChB;;EAEA;IACE,kCAAkC;IAClC,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;IACtB,oCAAoC;IACpC,yCAAyC;IACzC,oCAAoC;IACpC,YAAY;IACZ,uBAAuB;;EAEzB","sourcesContent":["@media only screen and (max-width: 1400px) {\n    .vraShiftsMediaQuery {\n      width: 76vw;\n      /* min-width: 60vw; */\n      overflow-x: scroll;\n      /* border: 1px solid black !important; */\n      justify-content: center;\n      text-align: center;\n\n    }\n  }\n  \n  @media only screen and (min-width: 1400px) {\n    .vraShiftsMediaQuery {\n      width: 80vw;\n      /* min-width: 60vw; */\n      overflow-x: scroll;\n    /* width: 20vw !important; */\n    /* border: 1px solid black !important; */\n    justify-content: center;\n    text-align: center;\n\n    }\n  }\n\n\n  .vraShiftsModalHeading{\n    font-family: \"Inter\";\nfont-size: 18px;\nfont-weight: 600;\nline-height: 22px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:#0070E9;\nmargin-left: 2%;\nmargin-bottom: 2%;\n    \n  }\n  .VraShiftsTitle{\n    font-family: \"Inter\";\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 22px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color:#0070E9\n\n  }\n\n  .editlabelinroster{\n    font-family: \"Inter\";\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 16.94px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color: #002C5D;\n    white-space: nowrap;\noverflow: hidden;\ntext-overflow: ellipsis;\nmargin-bottom: 5px;\n  }\n\n  .allcardsparentgrid{\n    justify-content: center !important;\n    margin-top: 1% !important;\n  }\n  .cardinmasterRoster{\n    border-radius: 10px;\n    margin: auto;\n    justify-content: center;\n    padding: 20px !important;\n  }\n\n  .reset-btnforroster{\n    font-family: \"Inter\"!important;\n    font-size: 16px!important;\n    font-weight: 600!important;\n    margin-right: 20px!important;\n    border-radius: 3px!important;\n    color: white!important;\n    background-color: #fe602f !important;\n    /* border: 2px solid #fe602f!important; */\n    text-transform: capitalize!important;\n    margin: auto;\n    justify-content: center;\n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
